// Dummy data for all pages based on IgniteNext workflow

export const studentData = {
  idea: {
    startupName: "EcoTrack",
    stage: "Spark",
    currentStage: 1,
    stages: [
      { name: "Spark", status: "active", completed: true },
      { name: "Shape", status: "pending", completed: false },
      { name: "Structure", status: "pending", completed: false },
      { name: "Scale", status: "pending", completed: false },
      { name: "Shine", status: "pending", completed: false },
    ],
    description: "A sustainability platform that helps businesses track and reduce their carbon footprint through AI-powered analytics.",
    problemStatement: "Businesses struggle to accurately measure and reduce their environmental impact due to lack of transparent tracking tools.",
    targetIndustry: "Manufacturing, Retail, Technology",
    category: "Sustainability",
    targetAudience: "Mid-size businesses (50-500 employees) committed to sustainability",
    mentor: {
      name: "Dr. Sarah Chen",
      email: "sarah.chen@ignitenext.com",
      linkedin: "linkedin.com/in/sarahchen",
      expertise: "Sustainability, Product Management",
    },
    score: {
      total: 45,
      max: 50,
      breakdown: {
        problemClarity: 9,
        originality: 8,
        impactPotential: 9,
        relevance: 9,
        researchDepth: 10,
      },
    },
  },
  sessions: [
    {
      id: 1,
      mentor: "Dr. Sarah Chen",
      date: "2024-12-05",
      time: "2:00 PM",
      status: "completed",
      notes: "Discussed problem validation and next steps for customer discovery",
    },
    {
      id: 2,
      mentor: "Dr. Sarah Chen",
      date: "2024-12-12",
      time: "2:00 PM",
      status: "upcoming",
      notes: "Review customer feedback and iterate on value proposition",
    },
  ],
  funding: {
    requested: 5000,
    approved: 0,
    tranches: [],
    status: "pending",
  },
  events: [
    {
      id: 1,
      name: "Bootcamp: Structure Stage",
      date: "2024-12-20",
      type: "Bootcamp",
      description: "Panel discussion and mini pitch for MVP validation",
      status: "scheduled",
    },
    {
      id: 2,
      name: "Pitch Practice Session",
      date: "2025-01-10",
      type: "Workshop",
      description: "Practice your pitch with feedback from multiple leaders",
      status: "scheduled",
    },
  ],
  messages: [
    {
      id: 1,
      from: "Dr. Sarah Chen",
      role: "mentor",
      subject: "Feedback on your idea submission",
      message: "Great start! I've reviewed your idea and have some suggestions for improvement...",
      date: "2024-12-01",
      read: true,
    },
    {
      id: 2,
      from: "Admin Team",
      role: "admin",
      subject: "Welcome to IgniteNext!",
      message: "Welcome to the program! Your idea has been accepted. Let's build something great together.",
      date: "2024-11-28",
      read: true,
    },
  ],
};

export const mentorData = {
  summary: {
    totalIdeas: 8,
    graduatedToLaunch: 3,
    activePortfolio: 5,
  },
  ideasForReview: [
    {
      id: 1,
      startupName: "EcoTrack",
      studentName: "John Doe",
      stage: "Spark",
      submittedDate: "2024-11-30",
      aiSummary: "Sustainability platform for carbon footprint tracking. Strong market potential in B2B space.",
      matchReason: "Aligns with your expertise in sustainability and product management",
      status: "pending",
    },
    {
      id: 2,
      startupName: "HealthSync",
      studentName: "Jane Smith",
      stage: "Shape",
      submittedDate: "2024-12-01",
      aiSummary: "Healthcare app connecting patients with providers. Needs validation on user acquisition strategy.",
      matchReason: "Your background in healthcare tech and growth strategies",
      status: "accepted",
    },
  ],
  engagements: [
    {
      id: 1,
      startupName: "EcoTrack",
      studentName: "John Doe",
      stage: "Spark",
      lastMeeting: "2024-12-05",
      nextMeeting: "2024-12-12",
      score: 45,
      status: "active",
    },
    {
      id: 2,
      startupName: "HealthSync",
      studentName: "Jane Smith",
      stage: "Shape",
      lastMeeting: "2024-11-28",
      nextMeeting: "2024-12-15",
      score: 38,
      status: "active",
    },
  ],
  calendar: [
    {
      id: 1,
      title: "Mentoring: EcoTrack",
      date: "2024-12-12",
      time: "2:00 PM - 3:00 PM",
      student: "John Doe",
      type: "scheduled",
    },
    {
      id: 2,
      title: "Mentoring: HealthSync",
      date: "2024-12-15",
      time: "10:00 AM - 11:00 AM",
      student: "Jane Smith",
      type: "scheduled",
    },
  ],
};

export const donorData = {
  summary: {
    totalContributions: 15000,
    studentsImpacted: 12,
    activeRecurring: 2,
  },
  donations: [
    {
      id: 1,
      amount: 5000,
      date: "2024-11-15",
      type: "one-time",
      status: "completed",
      invoice: "INV-2024-001",
    },
    {
      id: 2,
      amount: 2500,
      date: "2024-10-01",
      type: "recurring",
      status: "active",
      frequency: "monthly",
      nextPayment: "2024-12-01",
      invoice: "INV-2024-002",
    },
    {
      id: 3,
      amount: 7500,
      date: "2024-09-10",
      type: "one-time",
      status: "completed",
      invoice: "INV-2024-003",
    },
  ],
  recurring: [
    {
      id: 1,
      amount: 2500,
      frequency: "monthly",
      status: "active",
      nextPayment: "2024-12-01",
      startDate: "2024-10-01",
    },
  ],
  invoices: [
    {
      id: "INV-2024-001",
      amount: 5000,
      date: "2024-11-15",
      status: "paid",
      pdf: "/invoices/INV-2024-001.pdf",
    },
    {
      id: "INV-2024-002",
      amount: 2500,
      date: "2024-10-01",
      status: "paid",
      pdf: "/invoices/INV-2024-002.pdf",
    },
  ],
};

export const partnerData = {
  summary: {
    studentsSupported: 25,
    resourcesProvided: "AWS Credits, Development Tools",
    validityPeriod: "2024-01-01 to 2025-12-31",
  },
  contributions: [
    {
      id: 1,
      type: "AWS Credits",
      amount: "$10,000 worth",
      studentsUsing: 15,
      validity: "2024-01-01 to 2025-12-31",
      status: "active",
    },
    {
      id: 2,
      type: "Development Tools",
      amount: "50 licenses",
      studentsUsing: 10,
      validity: "2024-06-01 to 2025-06-01",
      status: "active",
    },
  ],
  requests: [
    {
      id: 1,
      type: "Resource Request",
      from: "John Doe - EcoTrack",
      request: "AWS credits for MVP deployment",
      date: "2024-12-05",
      status: "pending",
    },
    {
      id: 2,
      type: "Workshop Request",
      from: "Admin Team",
      request: "Technical workshop on cloud infrastructure",
      date: "2024-11-20",
      status: "approved",
    },
  ],
};

export const sponsorData = {
  summary: {
    tier: "Gold",
    totalAmount: 25000,
    studentsImpacted: 30,
    eventsSponsored: 3,
  },
  brandAssets: [
    {
      id: 1,
      name: "Company Logo - Main",
      uploaded: "2024-10-01",
      status: "active",
      url: "/brand-assets/logo-main.png",
    },
    {
      id: 2,
      name: "Company Logo - White Background",
      uploaded: "2024-10-01",
      status: "active",
      url: "/brand-assets/logo-white.png",
    },
  ],
  sponsorshipHistory: [
    {
      id: 1,
      event: "Demo Day 2024",
      amount: 15000,
      date: "2024-11-15",
      visibility: "Gold Tier - Logo on all materials",
      status: "completed",
    },
    {
      id: 2,
      event: "Bootcamp Fall 2024",
      amount: 5000,
      date: "2024-09-10",
      visibility: "Silver Tier - Logo on event page",
      status: "completed",
    },
  ],
  invoices: donorData.invoices.map(inv => ({ ...inv, event: "Demo Day 2024" })),
};

export const investorData = {
  summary: {
    startupsReviewed: 15,
    investmentsMade: 3,
    totalInvested: 75000,
    upcomingPitchDay: "2025-01-26",
  },
  pitchDocuments: [
    {
      id: 1,
      startupName: "EcoTrack",
      stage: "Shine",
      pitchDeck: "/pitches/ecotrack-deck.pdf",
      demoLink: "https://demo.ecotrack.com",
      traction: {
        users: 150,
        revenue: 5000,
        growth: "25% MoM",
      },
      fundingAsk: 100000,
      date: "2024-12-10",
    },
    {
      id: 2,
      startupName: "HealthSync",
      stage: "Shine",
      pitchDeck: "/pitches/healthsync-deck.pdf",
      demoLink: "https://demo.healthsync.com",
      traction: {
        users: 200,
        revenue: 8000,
        growth: "30% MoM",
      },
      fundingAsk: 150000,
      date: "2024-12-08",
    },
  ],
  investments: [
    {
      id: 1,
      startupName: "TechFlow",
      amount: 25000,
      date: "2024-11-01",
      status: "committed",
      agreement: "/agreements/techflow-mou.pdf",
    },
    {
      id: 2,
      startupName: "DataViz",
      amount: 50000,
      date: "2024-10-15",
      status: "completed",
      agreement: "/agreements/dataviz-mou.pdf",
    },
  ],
};

export const adminData = {
  kpis: {
    totalIdeas: 45,
    activeMentors: 25,
    totalFunding: 250000,
    studentsInProgram: 45,
    graduationRate: "15%",
  },
  ideas: [
    {
      id: 1,
      startupName: "EcoTrack",
      studentName: "John Doe",
      stage: "Spark",
      mentor: "Dr. Sarah Chen",
      score: 45,
      status: "active",
      submittedDate: "2024-11-30",
    },
    {
      id: 2,
      startupName: "HealthSync",
      studentName: "Jane Smith",
      stage: "Shape",
      mentor: "Dr. Sarah Chen",
      score: 38,
      status: "active",
      submittedDate: "2024-11-15",
    },
    {
      id: 3,
      startupName: "TechFlow",
      studentName: "Mike Johnson",
      stage: "Shine",
      mentor: "Prof. David Kim",
      score: 48,
      status: "graduated",
      submittedDate: "2024-09-01",
    },
  ],
  mentors: [
    {
      id: 1,
      name: "Dr. Sarah Chen",
      email: "sarah.chen@ignitenext.com",
      expertise: ["Sustainability", "Product Management"],
      ideasMentoring: 5,
      status: "active",
    },
    {
      id: 2,
      name: "Prof. David Kim",
      email: "david.kim@ignitenext.com",
      expertise: ["Healthcare Tech", "Growth"],
      ideasMentoring: 8,
      status: "active",
    },
  ],
  donors: [
    {
      id: 1,
      name: "John Smith",
      totalDonated: 15000,
      donations: 3,
      status: "active",
    },
    {
      id: 2,
      name: "ABC Foundation",
      totalDonated: 50000,
      donations: 1,
      status: "active",
    },
  ],
  events: [
    {
      id: 1,
      name: "Bootcamp: Structure Stage",
      date: "2024-12-20",
      type: "Bootcamp",
      participants: 12,
      status: "scheduled",
    },
    {
      id: 2,
      name: "Pitch Day 2025",
      date: "2025-01-26",
      type: "Pitch Day",
      participants: 8,
      status: "scheduled",
    },
  ],
};

// Mock ideas data for IdeaDetail component
export const ideasDetailData = {
  1: {
    id: 1,
    title: "EcoTrack",
    description:
      "A sustainable technology platform that helps businesses reduce their carbon footprint through AI-driven insights and actionable recommendations.",
    submissionDate: "20 Jan 2025",
    currentStage: 0,
    daysRemaining: 27,
    stages: [
      { name: "Spark", id: 0 },
      { name: "Shape", id: 1 },
      { name: "Structure", id: 2 },
      { name: "Scale", id: 3 },
      { name: "Shine", id: 4 },
    ],
    problemStatement: "EcoTrack aims to address the challenges faced by small business owners in managing their finances. Many entrepreneurs struggle with tracking expenses, understanding cash flow, and accessing timely financial insights. This often leads to poor financial decisions and increased stress.",
    proposedSolution: "FinTrack offers a comprehensive solution tailored for small business owners to simplify financial management. By providing an intuitive platform that tracks expenses in real-time, entrepreneurs can easily monitor their cash flow. Our unique value proposition lies in delivering actionable financial insights through advanced analytics.",
    targetAudience: "Success is empowering businesses with the tools they need to make a measurable impact on the environment and drive meaningful change.",
    existingAlternatives: "Success is empowering businesses with the tools they need to make a measurable impact on the environment and drive meaningful change.",
    primaryImpact: "Success is empowering businesses with the tools they need to make a measurable impact on the environment and drive meaningful change.",
    submitter: {
      name: "Chris Dsouza",
      avatar: "https://i.pravatar.cc/32?img=33",
      email: "chris@gmail.com",
    },
    rubricsScores: [
      {
        id: 1,
        name: "Problem Clarity",
        score: 6,
        maxScore: 10,
        icon: "lucide:monitor",
        color: "bg-blue-500",
        comment: "",
      },
      {
        id: 2,
        name: "Vision and Ambition",
        score: 8,
        maxScore: 10,
        icon: "lucide:shopping-bag",
        color: "bg-pink-500",
        comment: "",
      },
      {
        id: 3,
        name: "Originality",
        score: 7,
        maxScore: 10,
        icon: "lucide:shopping-cart",
        color: "bg-blue-600",
        comment: "",
      },
      {
        id: 4,
        name: "Impact Potential",
        score: 9,
        maxScore: 10,
        icon: "lucide:link",
        color: "bg-green-500",
        comment: "",
      },
      {
        id: 5,
        name: "Research Depth",
        score: 9,
        maxScore: 10,
        icon: "lucide:link",
        color: "bg-green-500",
        comment: "",
      },
    ],
    customerDeepDiveNotes: "I think this is a great idea.",
    numberOfMentors: 3,
    overallScore: 39,
    maxOverallScore: 50,
    rejectionMessage: "Unfortunately Innovator, you won't be moving on to the next stage. Based on your mentor's review and score, you will not be able to proceed along the IgniteNext track.",
    teamMembers: [
      {
        id: 1,
        name: "Olivia Rhye",
        email: "olivia@gmail.com",
        avatar: "https://i.pravatar.cc/32?img=12",
        role: "Founder & CEO",
      },
      {
        id: 2,
        name: "Scott Adams",
        email: "scott@gmail.com",
        avatar: "https://i.pravatar.cc/32?img=20",
        role: "CTO",
      },
      {
        id: 3,
        name: "Jenkins Dorwart",
        email: "jenkins@gmail.com",
        avatar: "https://i.pravatar.cc/32?img=25",
        role: "Head of Marketing",
      },
    ],
    teamMentors: [
      {
        id: 1,
        name: "Olivia Rhye",
        email: "olivia@gmail.com",
        avatar: "https://i.pravatar.cc/32?img=12",
        type: "Primary Mentor",
      },
      {
        id: 2,
        name: "Scott Adams",
        email: "scott@gmail.com",
        avatar: "https://i.pravatar.cc/32?img=20",
        type: "Secondary Mentor",
      },
      {
        id: 3,
        name: "Jenkins Dorwart",
        email: "jenkins@gmail.com",
        avatar: "https://i.pravatar.cc/32?img=25",
        type: "Secondary Mentor",
      },
    ],
    files: [
      {
        id: 1,
        name: "Tech requirements.pdf",
        size: "200 KB",
        type: "pdf",
        fileTag: "Tech Requirements",
        uploadedOn: "10 Dec 2025",
        uploadedBy: {
          name: "Olivia Rhye",
          email: "olivia@gmail.com",
          avatar: "https://i.pravatar.cc/32?img=12",
        },
      },
      {
        id: 2,
        name: "Dashboard screenshot.jpg",
        size: "720 KB",
        type: "jpg",
        fileTag: "Dashboard Screenshot",
        uploadedOn: "10 Dec 2025",
        uploadedBy: {
          name: "Phoenix Baker",
          email: "phoenix@gmail.com",
          avatar: "https://i.pravatar.cc/32?img=15",
        },
      },
      {
        id: 3,
        name: "Dashboard prototype flow.doc",
        size: "16 MB",
        type: "doc",
        fileTag: "Prototype Recording",
        uploadedOn: "10 Dec 2025",
        uploadedBy: {
          name: "Lana Steiner",
          email: "lana@gmail.com",
          avatar: "LS",
        },
      },
    ],
    reviewCriteria: [
      { id: 1, criterion: "Innovation", score: 4, maxScore: 5, comment: "Strong innovative approach, but needs more market validation." },
      { id: 2, criterion: "Feasibility", score: 3, maxScore: 5, comment: "Technical feasibility is good, but resource allocation needs refinement." },
      { id: 3, criterion: "Market Potential", score: 4, maxScore: 5, comment: "Large target market, but competitive landscape is intense." },
      { id: 4, criterion: "Team Capability", score: 5, maxScore: 5, comment: "Excellent team with diverse skills and experience." },
    ],
    overallComment: "EcoTrack shows great promise with a strong team and innovative solution. Focus on market validation and resource planning for the next stage.",
  },
  2: {
    id: 2,
    title: "HealthSync",
    description:
      "Healthcare app connecting patients with providers. Needs validation on user acquisition strategy.",
    submissionDate: "19 Jan 2025",
    submitter: {
      name: "Sundar Anbu",
      avatar: "https://i.pravatar.cc/32?img=20",
      email: "sundar@gmail.com",
    },
    files: [],
    reviewCriteria: [],
    overallScore: 0,
    maxOverallScore: 0,
    overallComment: "No review data available for this idea.",
  },
};

